import { attachmentApi } from '../api/attachment-api';
import { apiConfig } from '../api/config';
import { notify } from '../components/basic/notify';
import { useWaiting } from '../components/basic/use-waiting';
import { useImage } from './use-image';

export const useProfileImage = (userName?: string) => {
    const url = userName
        ? apiConfig.attachmentUrl + `/user-profile-image?userName=${userName}`
        : apiConfig.attachmentUrl + `/user-profile-image`;
    const image = useImage(url);
    const waiting = useWaiting();

    const upload = (file: any) => {
        const uploadUrl = apiConfig.attachmentUrl + '/upload-user-profile-image';
        waiting.start();
        attachmentApi
            .attach(uploadUrl, null, null, file)
            .then(image.refresh)
            .catch(notify.error)
            .finally(waiting.stop);
    };

    return {
        ...image,
        upload,
    };
};
